import { styled, apply } from 'lib/styled'

export const Input = styled.input(
  apply('border text-black rounded-lg w-full', {
    border: '1px solid #CCCCCC',
    padding: '.5rem 1rem',
    fontSize: '0.9375rem',
    height: '40px',
    '&:read-only': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'default',
    },
  })
)
